export default __webpack_public_path__ + "static/BanImg3-35437a42c26aa4a957775c9596149a87.webp";